module.exports = __webpack_public_path__ + "static/media/caret-circle-up.ed21625f.svg";